import { AuthApi } from '@linktivity/hirakuza';
import config from '../config';

const authApi = new AuthApi(config);

export default authApi;
